/** @app — application layer; owned per-fork (LMS / OTT). See PLATFORM_FILES.md. */
import type { ReactNode } from 'react';
import { COURSE_DETAIL_CSS } from './styles';

// CourseLayout — the page-level chrome.
//
// Renders the shared CSS exactly once, then a 2-column grid for
// desktop (main content + sticky sidebar). On <1024px it stacks:
// sidebar first, then main, so mobile users land on the price card
// AND title together above the fold.
//
// Sticky note
// -----------
// The sidebar is `position: sticky`. To extend how far down it
// stays sticky, the `full` slot — Related Courses — renders INSIDE
// the main column rather than as a sibling below the grid. CSS
// sticky only sticks within its parent's bounds, so putting the
// related row inside the same column as the tab content means the
// sidebar follows the user all the way to "Benzer Eğitimler" before
// finally releasing. This was a fix for the round-4 complaint
// that the card stopped sticking too early.

export interface CourseLayoutProps {
  /** Above-the-tabs region — hero + (variant-specific) priority blocks. */
  hero: ReactNode;
  /** Main content column (typically <CourseTabs>). */
  main: ReactNode;
  /** Sticky right-column content (typically <PriceCard>). */
  sidebar: ReactNode;
  /** "Below the fold" section — typically Related Courses. Renders
   *  inside the main column (after `main`) so the sticky sidebar
   *  stays visible while the user scrolls through it. */
  full?: ReactNode;
}

export function CourseLayout({ hero, main, sidebar, full }: CourseLayoutProps) {
  return (
    <div className="cd-root">
      <style dangerouslySetInnerHTML={{ __html: COURSE_DETAIL_CSS }} />
      <div className="cd-shell">
        {hero}
        <div className="cd-grid">
          <div className="cd-main-col">
            {main}
            {full}
          </div>
          <div className="cd-sidebar-col">{sidebar}</div>
        </div>
      </div>
    </div>
  );
}
